import { render, staticRenderFns } from "./u-file-input-outlined-pill.vue?vue&type=template&id=de9cc156&scoped=true&"
import script from "./u-file-input-outlined-pill.vue?vue&type=script&lang=js&"
export * from "./u-file-input-outlined-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9cc156",
  null
  
)

export default component.exports